import {UPDATE_TOGGLE} from '../constants';
import store from '../store'

export const updateToggle = (toggle) =>{
    store.dispatch({ type: UPDATE_TOGGLE, toggle})
};